import { useMutation, useQuery } from '@apollo/client'
import React, { useEffect, useRef, useState } from 'react'
import ReactLoading from 'react-loading'
import IconDot from 'assets/images/icon-dot.svg'
import IconInformation from 'assets/images/icon-information.svg'
import ButtonBase from 'components/partials/button'
import SingleRowActionBase from 'components/partials/singleRowActionBase'
import { notify } from 'components/toastify'
import { MESSAGES, STATUS } from 'constants/messages'
import { useSession } from 'helpers/checkSession'
import { DELETE_EMAIL_SUBJECT_SETTING, GET_ALL_EMAIL_SUBJECT_DATA } from 'queries/adminPortal'
import { SubjectEmailInfo } from 'pages/admin-portal/components/models'
import DetailSubjectItemDialog from './detailSubjectItem'
import { ActionItem, VariablesSubjectList } from '../../interface'
import SubjectItemDialog from './subjectItem'
import { tableEmailConfig } from './tableEmailConfig'
import DialogBasic from 'components/dialog/dialogBasic'
const SubjectManagement = () => {
  const [isLoadingTable, _setIsLoadingTable] = useState<boolean>(false)
  const [isOpenModalDeleteSubject, setIsOpenModalDeleteSubject] = useState<boolean>(false)
  const [isOpenModalEditSubject, setIsOpenModalSubject] = useState<boolean>(false)
  const [isEditSubject, setIsEditSubject] = useState<boolean>(false)
  const [_isViewDetailSubject, setIsViewDetailSubject] = useState<boolean>(false)
  const [isOpenModalViewDetailSubject, setIsOpenModalViewDetailSubject] = useState<boolean>(false)
  const [listSubjects, setListSubjects] = useState<SubjectEmailInfo[]>([])

  const menuRef = useRef<HTMLDivElement>(null)
  const { sessionChecking, handleErrorSession } = useSession()
  const [showAction, setShowAction] = useState<ActionItem>({
    id: null,
    status: false,
    lastItem: null,
  })
  const defaultSubjectEmail = {
    id: '0',
    createdAt: null,
    tDayConfig: {
      configId: '',
      key: '',
      value: '',
    },
    startSubject: '',
    cancelSubject: '',
    textTemplateURL: '',
    action: '',
    status: false,
    emailTemplateURL: '',
  }
  const [currentValueSubject, setCurrentValueSubject] =
    useState<SubjectEmailInfo>(defaultSubjectEmail)
  const [deleteEmailSubjectSetting] = useMutation(DELETE_EMAIL_SUBJECT_SETTING)
  const { data: getEmailSubjectSettingData, refetch: getDataSubjectRefetch } = useQuery(
    GET_ALL_EMAIL_SUBJECT_DATA,
    {
      fetchPolicy: 'no-cache',
      variables: {
        limit: 200,
        page: 1,
      },
    } as VariablesSubjectList,
  )

  useEffect(() => {
    if (
      getEmailSubjectSettingData &&
      getEmailSubjectSettingData.getAllEmailManagementConfig?.items.length > 0
    ) {
      setListSubjects(
        getEmailSubjectSettingData.getAllEmailManagementConfig.items.map((item: any) => {
          const firstStepQuery = item.subEmailManagementConfig.filter(
            (subjectItem: any) => subjectItem.step === 1,
          )
          const firstStep = firstStepQuery && firstStepQuery.length > 0 ? firstStepQuery[0] : {}
          return {
            id: item.emailManagementConfigId,
            startSubject: item.startSubject,
            cancelSubject: item.cancelSubject,
            createdAt: item.createdAt,
            emailTemplateURL: firstStep.emailTemplateURL,
            numberOfDayApply: firstStep.numberOfDayApply,
            action: firstStep.action,
            textTemplateURL: firstStep.textTemplateURL,
            subEmailManagementConfig: item.subEmailManagementConfig?.map((subItem: any) => subItem),
            status: true,
          }
        }),
      )
    } else {
      setListSubjects([])
    }
  }, [getEmailSubjectSettingData])

  const onHandleClickAction = (item: any) => {
    if (showAction.lastItem == item.id) {
      return
    }
    setShowAction({
      id: item.id,
      status: true,
      lastItem: item.id,
    })
    setCurrentValueSubject({
      ...item,
    })
  }

  useEffect(() => {
    const handleClickOutSide = (e: any) => {
      if (menuRef && !menuRef.current?.contains(e.target)) {
        setShowAction({ lastItem: showAction.id, id: null, status: false })
      }
    }
    document.addEventListener('mousedown', handleClickOutSide)
    return () => {
      document.removeEventListener('mousedown', handleClickOutSide)
    }
  }, [showAction])

  const onHandleEditSubjectItem = () => {
    setIsEditSubject(true)
    setIsOpenModalSubject(true)
  }

  const onHandleViewDetailSubjectItem = () => {
    setIsViewDetailSubject(true)
    setIsOpenModalViewDetailSubject(true)
  }

  const onHandleAddSubjectItem = () => {
    setIsEditSubject(false)
    setIsOpenModalSubject(true)
  }

  const handleCloseEditInfoDialog = () => {
    setIsOpenModalSubject(false)
    setIsEditSubject(false)
    setCurrentValueSubject(defaultSubjectEmail)
  }

  const handleCloseViewDetailDialog = () => {
    setIsOpenModalViewDetailSubject(false)
    setIsViewDetailSubject(false)
    setCurrentValueSubject(defaultSubjectEmail)
  }

  const onHandleToggleDeleteSubject = async () => {
    setIsOpenModalDeleteSubject(true)
  }

  const handleRefetchData = () => {
    getDataSubjectRefetch()
  }

  const handleCloseDeleteSubjectDialog = () => {
    setIsOpenModalDeleteSubject(false)
  }
  const onHandleDeleteSubject = async () => {
    if ((await sessionChecking()) === false) {
      try {
        await deleteEmailSubjectSetting({
          variables: {
            emailManagementConfigId: currentValueSubject.id,
          },
        })
        setIsOpenModalDeleteSubject(false)
        getDataSubjectRefetch()
        notify(MESSAGES.SUCCESS.S_SUBJECT_UPDATE_SETTING, STATUS.SUCCESS)
      } catch (error) {
        handleErrorSession(error, MESSAGES.ERROR.E_TRY_AGAIN)
        setIsOpenModalDeleteSubject(false)
      }
    }
  }
  return (
    <div className="mt-4">
      <div className="flex items-center justify-between pb-5">
        <p className="text-headline5A text-neutral-1 md:ml-[-40px]">Subject management</p>
        <ButtonBase
          className="w-[200px] md:mr-[-40px]"
          bgHover="bg-violet-900"
          onClick={onHandleAddSubjectItem}
          bgDisabled="bg-violet-600"
        >
          Add new
        </ButtonBase>
      </div>
      <div className="md:mr-[-40px] md:ml-[-40px]">
        <div className="w-full top-[88px] border-2 border-neutral-6 bg-neutral-8 rounded-2xl">
          <ul className="flex bg-primary-shade4 px-6 py-5 justify-start rounded-t-[14px]">
            {tableEmailConfig.map((config) => {
              return (
                <li
                  key={`sub-config-header-${config.header.id}`}
                  className={config.header.className}
                >
                  <span className="text-base font-semibold font-montserrat text-neutral-2">
                    {config.header.label}
                  </span>
                </li>
              )
            })}
            <li className="w-[2%]"></li>
          </ul>
          {isLoadingTable ? (
            <div className="flex justify-center p-5">
              <ReactLoading type="spin" color="#A989D8" height={30} width={30} />
            </div>
          ) : listSubjects !== null && listSubjects.length > 0 ? (
            <React.Fragment>
              <div className="mt-5 ">
                {listSubjects?.map((item) => (
                  <ul
                    className="flex justify-start h-auto px-6 py-5 mb-3 font-montserrat text-body2 text-neutral-3 hover:bg-neutral-7 hover:text-neutral-1 hover:h-auto"
                    key={item.id}
                  >
                    {tableEmailConfig.map((config) => {
                      const temp: any = { ...item }
                      if (Object.keys(temp).includes(config.row.key)) {
                        if (config.row.key === 'subEmailManagementConfig') {
                          return (
                            <li className="w-[8%]" key={`table-row-total-stage`}>
                              <p>{temp['subEmailManagementConfig'].length}</p>
                            </li>
                          )
                        }
                        return (
                          <li className={config.row.className} key={`table-row-${config.row.key}`}>
                            <p>{temp[config.row.key]}</p>
                          </li>
                        )
                      }
                    })}

                    <button className="w-[2%] mb-auto" onClick={() => onHandleClickAction(item)}>
                      <div className="relative ">
                        <img src={IconDot} alt="Icon-Dot" className="" />
                        {showAction?.id === item.id && showAction.status && (
                          <div
                            className={`absolute right-[2px] h-auto p-3 border shadow-2xl w-60 border-neutral-7 bg-neutral-8 rounded-xl z-10`}
                            ref={menuRef}
                          >
                            <SingleRowActionBase
                              icon={IconInformation}
                              handleAction={onHandleViewDetailSubjectItem}
                              action="view"
                              txt="View Detail"
                            />
                            <hr className="my-1 border-t-neutral-7" />
                            <SingleRowActionBase
                              handleAction={onHandleEditSubjectItem}
                              action="edit"
                              txt="Edit"
                            />
                            <hr className="my-1 border-t-neutral-7" />
                            <SingleRowActionBase
                              handleAction={onHandleToggleDeleteSubject}
                              action="delete"
                              txt="Delete"
                            />
                          </div>
                        )}
                      </div>
                    </button>
                  </ul>
                ))}
              </div>
              {isOpenModalDeleteSubject && (
                <DialogBasic
                  modalIsOpen={isOpenModalDeleteSubject}
                  title="Delete Subject Setting"
                  confirmation="Are you sure you want to permanently delete this setting"
                  action="Delete"
                  handleCloseDialog={handleCloseDeleteSubjectDialog}
                  handleAction={onHandleDeleteSubject}
                />
              )}
              {isOpenModalEditSubject && (
                <SubjectItemDialog
                  modalIsOpen={isOpenModalEditSubject}
                  subjectInfo={currentValueSubject}
                  isEditSubject={isEditSubject}
                  handleCloseDialog={handleCloseEditInfoDialog}
                  handleRefetchData={handleRefetchData}
                />
              )}
              {isOpenModalViewDetailSubject && (
                <DetailSubjectItemDialog
                  emailManagementConfigId={currentValueSubject.id}
                  handleCloseDialog={handleCloseViewDetailDialog}
                  modalIsOpen={isOpenModalViewDetailSubject}
                />
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {isOpenModalEditSubject && (
                <SubjectItemDialog
                  modalIsOpen={isOpenModalEditSubject}
                  subjectInfo={currentValueSubject}
                  isEditSubject={isEditSubject}
                  handleCloseDialog={handleCloseEditInfoDialog}
                  handleRefetchData={handleRefetchData}
                />
              )}
              <p className="pt-5 pb-3 text-center text-body1 text-neutral-4">No data available.</p>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  )
}
export default SubjectManagement
